import { LineChart, LineChartProps } from '../../../../renderers/line-chart/line-chart.component';
import { VENDING_RECYCLE_SPOT_FILL_RATE_LINE_CHART_DEFINITION } from './vending-recycle-spot-fill-rate-line-chart.definition';
import { VENDING_RECYCLE_SPOT_FILL_RATE_LINE_CHART_MOCK_DATA } from './vending-recycle-spot-fill-rate-line-chart.mock';

export const VendingRecycleSpotFillRateLineChart = (props: LineChartProps) => (
    <LineChart
        {...props}
        showArea
    />
);

VendingRecycleSpotFillRateLineChart.definition = VENDING_RECYCLE_SPOT_FILL_RATE_LINE_CHART_DEFINITION;
VendingRecycleSpotFillRateLineChart.mockData = VENDING_RECYCLE_SPOT_FILL_RATE_LINE_CHART_MOCK_DATA;
